import React from 'react';
import tabStyles from './EnquiriesTab.module.css';
import { isMobile } from '../../../../Constants';
import { titleCase } from '../../../../Utility';
import { DataGhost } from '../../../Planning/components/EmptyState';
import Pagination from 'react-js-pagination';

const EnquiriesTab = ({
    approvalList = [],
    payload = [],
    setPayload,
    changeHandler,
    getOnChange,
    skipActive,
    totalCount,
    show,
    ApprovalHandler,
    enquiryTransition,
    selectedTab,
}) => {
    const mobile = isMobile();
    const selectedPayload = Array.isArray(payload) ? payload : [];

    const getLastRate = (rateList) => {
        if (!Array.isArray(rateList) || rateList.length === 0) return null;
        return rateList[rateList.length - 1];
    };

    const remarksOnchange = (e, enquiryId, transporterId) => {
        const updatedPayload = selectedPayload.map((item) => {
            if (
                item.truck_enquiry_id === enquiryId &&
                item.transporter_id === transporterId
            ) {
                return { ...item, remark: e.target.value };
            }
            return item;
        });
        setPayload(updatedPayload);
    };

    const isDisabled = (enquiryId, transporterId) => {
        return !selectedPayload.some(
            (item) =>
                item.truck_enquiry_id === enquiryId &&
                item.transporter_id === transporterId
        );
    };

    const getTenure = (tenure) => {
        if (!tenure) return 'NA';
        if (typeof tenure === 'string') return tenure;
        if (Array.isArray(tenure) && tenure.length > 0) {
            return tenure[0].label || tenure[0].value || 'NA';
        }
        if (typeof tenure === 'object') {
            return tenure.label || tenure.value || 'NA';
        }
        return 'NA';
    };

    const formatRate = (value) => {
        if (value === null || value === undefined || value === '') return 'NA';
        const numericValue = Number(String(value).replace(/,/g, ''));
        if (Number.isFinite(numericValue)) {
            return numericValue.toLocaleString('en-IN');
        }
        return String(value);
    };

    const showRejectButtons =
        (enquiryTransition === 'yes' || enquiryTransition === true) &&
        selectedTab !== 'expiredEnquiries';

    const selectedHasIndentCreated = selectedPayload.some((sel) => {
        const enquiry = approvalList.find(
            (e) => e.truck_enquiry_id === sel.truck_enquiry_id
        );
        return enquiry?.indent_created === true;
    });

    /* ─── Column widths (must sum to 100%) ─── */
    const COL = {
        check: '4%',
        user: '6%',
        adhoc: '11%',
        origin: '9%',
        dest: '9%',
        truckType: '9%',
        numTruck: '5%',
        tenure: '7%',
        dop: '8%',
        transporter: '11%',
        rate: '8%',
        remarks: '13%',
    };

    return (
        <>
            {approvalList.length > 0 ? (
                <div>
                    <div
                        className={tabStyles.scrollList}
                        style={{ height: 'auto', maxHeight: '55vh', overflowY: 'auto' }}
                    >
                        {/* ── Table header (desktop only) ── */}
                        {!mobile && (
                            <div className={tabStyles.tableHeader}>
                                {/* checkbox spacer */}
                                <div style={{ width: COL.check, flexShrink: 0 }} />

                                <div style={{ width: COL.user, flexShrink: 0, fontSize: '12px', fontWeight: 'bold' }}>
                                    User
                                </div>
                                <div style={{ width: COL.adhoc, flexShrink: 0, fontSize: '12px', fontWeight: 'bold' }}>
                                    Adhoc ID
                                </div>
                                <div style={{ width: COL.origin, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Origin
                                </div>
                                <div style={{ width: COL.dest, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Destination
                                </div>
                                <div style={{ width: COL.truckType, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Truck Type
                                </div>
                                <div style={{ width: COL.numTruck, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    # Trucks
                                </div>
                                <div style={{ width: COL.tenure, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Contract Tenure
                                </div>
                                <div style={{ width: COL.dop, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Date of Placement
                                </div>
                                <div style={{ width: COL.transporter, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Transporter Name
                                </div>
                                <div style={{ width: COL.rate, flexShrink: 0, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Rate Accepted
                                </div>
                                <div style={{ flex: 1, fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>
                                    Remarks
                                </div>
                            </div>
                        )}

                        {/* ── Enquiry rows ── */}
                        <div>
                            {approvalList.map((item, index) => {
                                const matchingTransporters = (
                                    item.transporter_list ||
                                    item.transporter_rate_list ||
                                    []
                                ).filter((transporter) => {
                                    const lastRate = getLastRate(transporter.rate_list);
                                    return (
                                        lastRate &&
                                        lastRate.bid_status === 'accepted' &&
                                        (
                                            transporter.main_status === 'approval_pending' ||
                                            lastRate.main_status === 'approval_pending' ||
                                            (
                                                transporter.main_status !== 'approved' &&
                                                lastRate.main_status !== 'approved'
                                            )
                                        )
                                    );
                                });

                                if (matchingTransporters.length === 0) return null;

                                // ── Calculate Ranking (L1, L2, etc.) based on rate ──
                                const rankedList = [...matchingTransporters].sort((a, b) => {
                                    const rateA = Number(String(getLastRate(a.rate_list)?.rate || "").replace(/,/g, "")) || Infinity;
                                    const rateB = Number(String(getLastRate(b.rate_list)?.rate || "").replace(/,/g, "")) || Infinity;
                                    return rateA - rateB;
                                });
                                const rankMap = {};
                                rankedList.forEach((t, i) => {
                                    rankMap[t.transporter_id] = `L${i + 1}`;
                                });

                                const lane = item.lane_details || item;
                                const origin = lane.origin || item.origin;
                                const destination = lane.destination || item.destination;
                                const truckTypes = lane.truck_types || item.truck_types;
                                const truckRequired = lane.truck_required || item.truck_required;
                                const contractTenure = lane.contract_tenure || item.contract_tenure;
                                const dueDate = lane.due_date || item.due_date;

                                const originName =
                                    origin?.location?.location ||
                                    origin?.location_name ||
                                    origin?.label ||
                                    'NA';
                                const destName =
                                    destination?.location?.location ||
                                    destination?.location_name ||
                                    destination?.label ||
                                    'NA';
                                const truckLabel = Array.isArray(truckTypes)
                                    ? truckTypes.map((t) => t.label || t.value || t).join(', ')
                                    : truckTypes?.label || truckTypes?.value || truckTypes || 'NA';

                                const userEmail = item.email
                                    ? titleCase(item.email.split('@')[0])
                                    : 'User';
                                const adhocId = item.display_adhoc_id || 'NA';
                                const hasMultipleQuotes = matchingTransporters.length > 1;
                                const indentCreated = item.indent_created === true;

                                return (
                                    <div
                                        key={`enquiry-${item.truck_enquiry_id || index}`}
                                        style={{
                                            borderBottom: '1px solid #e8e8e8',
                                            borderLeft: hasMultipleQuotes ? '3px solid #393185' : '3px solid transparent',
                                            backgroundColor: hasMultipleQuotes ? '#fafbff' : 'transparent',
                                            marginBottom: '4px',
                                        }}
                                    >
                                        {matchingTransporters.map((transporter, i) => {
                                            const lastRate = getLastRate(transporter.rate_list);
                                            const rate = formatRate(lastRate?.rate);
                                            const rateRemark = lastRate?.remark;

                                            const isSelected = selectedPayload.some(
                                                (sel) =>
                                                    sel.truck_enquiry_id === item.truck_enquiry_id &&
                                                    sel.transporter_id === transporter.transporter_id
                                            );
                                            const disableRemark = isDisabled(
                                                item.truck_enquiry_id,
                                                transporter.transporter_id
                                            );

                                            const isSubRow = i > 0;

                                            if (mobile) {
                                                /* ── Mobile layout ── */
                                                return (
                                                    <div
                                                        key={`m-${item.truck_enquiry_id}-${transporter.transporter_id}`}
                                                        style={{
                                                            padding: '5%',
                                                            margin: '1%',
                                                            border: '1px solid lightgrey',
                                                            borderRadius: '5px',
                                                            backgroundColor: isSubRow ? '#f5f6ff' : '#fff',
                                                        }}
                                                    >
                                                        {!isSubRow && (
                                                            <>
                                                                <div className={tabStyles.mobileField}>
                                                                    <b>User:</b> {userEmail}
                                                                </div>
                                                                <div className={tabStyles.mobileField}><b>Adhoc ID:</b> {adhocId}</div>
                                                                {indentCreated && (
                                                                    <div style={{ marginTop: '4px', marginBottom: '2px' }}>
                                                                        <span
                                                                            style={{
                                                                                display: 'inline-block',
                                                                                fontSize: '10px',
                                                                                fontWeight: 600,
                                                                                color: '#393185',
                                                                                backgroundColor: '#ECEBFA',
                                                                                border: '1px solid #cfcbf0',
                                                                                borderRadius: '10px',
                                                                                padding: '2px 8px',
                                                                            }}
                                                                        >
                                                                            Indent Created
                                                                        </span>
                                                                    </div>
                                                                )}
                                                                <div className={tabStyles.mobileField}><b>Origin:</b> {originName}</div>
                                                                <div className={tabStyles.mobileField}><b>Destination:</b> {destName}</div>
                                                                <div className={tabStyles.mobileField}><b>Truck Type:</b> {truckLabel}</div>
                                                                <div className={tabStyles.mobileField}><b># Trucks:</b> {truckRequired || 'NA'}</div>
                                                                <div className={tabStyles.mobileField}><b>Contract Tenure:</b> {getTenure(contractTenure)}</div>
                                                                <div className={tabStyles.mobileField}><b>Date of Placement:</b> {dueDate || 'NA'}</div>
                                                            </>
                                                        )}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelected}
                                                                style={{ height: '15px', width: '15px', cursor: 'pointer' }}
                                                                className={tabStyles.checkbox}
                                                                onChange={(e) => changeHandler(e, item, transporter)}
                                                            />
                                                            <b>Transporter:</b> {transporter.transporter_name || 'NA'}
                                                        </div>
                                                        <div className={tabStyles.mobileRate}>
                                                            {rate === 'NA' ? 'NA' : `₹${rate}`}
                                                        </div>
                                                        {rateRemark && (
                                                            <div className={tabStyles.rateRemark}>Note: {rateRemark}</div>
                                                        )}
                                                        <div className={tabStyles.mobileRemarkWrapper}>
                                                            <input
                                                                disabled={disableRemark}
                                                                onChange={(e) => remarksOnchange(e, item.truck_enquiry_id, transporter.transporter_id)}
                                                                placeholder="Add approval remark..."
                                                                className={`form-control form-control-sm ${tabStyles.remarkInput} ${disableRemark ? tabStyles.remarkInputDisabled : tabStyles.remarkInputEnabled}`}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            /* ── Desktop layout ── */
                                            return (
                                                <div
                                                    key={`d-${item.truck_enquiry_id}-${transporter.transporter_id}`}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: isSubRow ? '6px 0 6px 0' : '10px 0',
                                                        borderTop: isSubRow ? '1px dashed #e0e2ec' : 'none',
                                                        backgroundColor: isSubRow ? '#f4f5ff' : 'transparent',
                                                        fontSize: '13px',
                                                    }}
                                                >
                                                    {/* Checkbox */}
                                                    <div style={{ width: COL.check, flexShrink: 0, textAlign: 'center' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            style={{ height: '15px', width: '15px', cursor: 'pointer' }}
                                                            className={tabStyles.checkbox}
                                                            onChange={(e) => changeHandler(e, item, transporter)}
                                                        />
                                                    </div>

                                                    {isSubRow ? (
                                                        /* ── Sub-row: single spanning cell showing which enquiry this belongs to ── */
                                                        <div style={{
                                                            width: '64%', /* sum of user+adhoc+origin+dest+truckType+numTruck+tenure+dop */
                                                            flexShrink: 0,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px',
                                                            paddingLeft: '6px',
                                                        }}>

                                                        </div>
                                                    ) : (
                                                        /* ── Main row: all enquiry detail columns ── */
                                                        <>
                                                            {/* User */}
                                                            <div style={{ width: COL.user, flexShrink: 0, fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {userEmail}
                                                            </div>

                                                            {/* Adhoc ID */}
                                                            <div style={{ width: COL.adhoc, flexShrink: 0, paddingRight: '4px' }}>
                                                                <div style={{ fontSize: '12px', color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    {adhocId}
                                                                </div>
                                                                {indentCreated && (
                                                                    <span
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            marginTop: '3px',
                                                                            fontSize: '10px',
                                                                            fontWeight: 600,
                                                                            color: '#393185',
                                                                            backgroundColor: '#ECEBFA',
                                                                            border: '1px solid #cfcbf0',
                                                                            borderRadius: '10px',
                                                                            padding: '1px 7px',
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        Indent Created
                                                                    </span>
                                                                )}
                                                            </div>

                                                            {/* Origin */}
                                                            <div style={{ width: COL.origin, flexShrink: 0, textAlign: 'center', fontSize: '13px' }}>
                                                                {originName !== 'NA' ? (
                                                                    <>
                                                                        <i className="fa fa-map-marker" style={{ color: '#393186', marginRight: '3px' }} />
                                                                        <span>{originName}</span>
                                                                    </>
                                                                ) : 'NA'}
                                                            </div>

                                                            {/* Destination */}
                                                            <div style={{ width: COL.dest, flexShrink: 0, textAlign: 'center', fontSize: '13px' }}>
                                                                {destName !== 'NA' ? (
                                                                    <>
                                                                        <i className="fa fa-map-marker" style={{ color: '#393186', marginRight: '3px' }} />
                                                                        <span>{destName}</span>
                                                                    </>
                                                                ) : 'NA'}
                                                            </div>

                                                            {/* Truck Type */}
                                                            <div style={{ width: COL.truckType, flexShrink: 0, textAlign: 'center', fontSize: '12px', color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {truckLabel}
                                                            </div>

                                                            {/* # Trucks */}
                                                            <div style={{ width: COL.numTruck, flexShrink: 0, textAlign: 'center', fontSize: '13px', color: '#555' }}>
                                                                {truckRequired || 'NA'}
                                                            </div>

                                                            {/* Contract Tenure */}
                                                            <div style={{ width: COL.tenure, flexShrink: 0, textAlign: 'center', fontSize: '12px', color: '#555' }}>
                                                                {getTenure(contractTenure)}
                                                            </div>

                                                            {/* Date of Placement */}
                                                            <div style={{ width: COL.dop, flexShrink: 0, textAlign: 'center', fontSize: '12px', color: '#555' }}>
                                                                {dueDate || 'NA'}
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* Transporter Name */}
                                                    <div style={{ width: COL.transporter, flexShrink: 0, textAlign: 'center', fontSize: '13px', color: '#333' }}>

                                                        {transporter.transporter_name || 'NA'}
                                                    </div>


                                                    <div style={{ width: COL.rate, flexShrink: 0, textAlign: 'center' }}>
                                                        <div style={{ fontWeight: '700', color: '#393185', fontSize: '14px', whiteSpace: 'nowrap' }}>
                                                            {rate === 'NA' ? (
                                                                <span style={{ color: '#999', fontWeight: 400, fontSize: '13px' }}>NA</span>
                                                            ) : (
                                                                <>
                                                                    ₹{rate}
                                                                    {hasMultipleQuotes && (
                                                                        <span style={{ fontSize: '11px', color: '#e67e22', marginLeft: '4px' }}>
                                                                            ({rankMap[transporter.transporter_id]})
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                        {rateRemark && (
                                                            <div style={{ fontSize: '10px', color: '#888', marginTop: '2px' }}>
                                                                Note: {rateRemark}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Remarks */}
                                                    <div style={{ flex: 1, paddingRight: '8px', display: 'flex', alignItems: 'center' }}>
                                                        <input
                                                            disabled={disableRemark}
                                                            onChange={(e) =>
                                                                remarksOnchange(
                                                                    e,
                                                                    item.truck_enquiry_id,
                                                                    transporter.transporter_id
                                                                )
                                                            }
                                                            placeholder="Add approval remark..."
                                                            className={`form-control form-control-sm ${tabStyles.remarkInput} ${disableRemark
                                                                ? tabStyles.remarkInputDisabled
                                                                : tabStyles.remarkInputEnabled
                                                                }`}
                                                            style={{ width: '100%', fontSize: '12px', height: '30px' }}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <center className="pt-4">
                        {showRejectButtons ? (
                            <>
                                <button
                                    type="button"
                                    className={`btn btn-sm btn-outline-danger mx-2 border border-danger${selectedHasIndentCreated ? '' : ' custom-hover'}`}
                                    disabled={selectedHasIndentCreated}
                                    style={
                                        selectedHasIndentCreated
                                            ? {
                                                opacity: 0.5,
                                                cursor: 'not-allowed',
                                                pointerEvents: 'none',
                                                backgroundColor: 'transparent',
                                                color: '#dc3545',
                                            }
                                            : {}
                                    }
                                    onClick={() => ApprovalHandler('close')}
                                >
                                    Reject and Close
                                </button>

                                <button
                                    type="button"
                                    className={`btn btn-sm btn-outline-secondary mx-2 border border-secondary${selectedHasIndentCreated ? '' : ' custom-hover'}`}
                                    disabled={selectedHasIndentCreated}
                                    style={
                                        selectedHasIndentCreated
                                            ? {
                                                opacity: 0.5,
                                                cursor: 'not-allowed',
                                                pointerEvents: 'none',
                                                backgroundColor: 'transparent',
                                                color: '#6c757d',
                                            }
                                            : {}
                                    }
                                    onClick={() => ApprovalHandler('open')}
                                >
                                    Reject and Open
                                </button>
                            </>
                        ) : null}

                        <button
                            className="btn btn-sm btn-primary mx-2"
                            onClick={() => ApprovalHandler('approve')}
                        >
                            Approve
                        </button>

                        {showRejectButtons && selectedHasIndentCreated && (
                            <div style={{ fontSize: '11px', color: '#e67e22', marginTop: '6px' }}>
                                Enquiries with an indent already created cannot be Rejected and Opened/Closed — only Approve is allowed for them.
                            </div>
                        )}
                    </center>

                    <center className="pt-2">
                        <Pagination
                            activePage={skipActive === 0 ? 1 : skipActive}
                            itemsCountPerPage={10}
                            totalItemsCount={totalCount}
                            onChange={(e) => getOnChange(e)}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </center>

                    <div
                        className="d-flex justify-content-end mt-2 pb-3"
                        style={{ fontSize: '12px', color: '#666' }}
                    >
                        <b>Note:&nbsp;</b> If the Date of Placement is expired then new
                        enquiry will be floated
                    </div>
                </div>
            ) : (
                show === false && (
                    <div className="mb-5 pb-5">
                        <center>
                            <DataGhost
                                title="Looks like you have no enquiries to approve"
                                hasSubtitle={false}
                            />
                        </center>
                    </div>
                )
            )}
        </>
    );
};


export default EnquiriesTab;